import { api } from '@here/api'
import { userId } from '@state'
import { createMemo, createResource, createSignal } from 'solid-js'

const getLatestSetups = async () => {
	const { data } = await api()
		.from('setup')
		.select('*')
		.order('created_at', { ascending: false })
		.limit(10)

	return data || undefined
}

const getTakenSetups = async () => {
  const p_user_id = userId()

  if (!p_user_id) {
    return undefined
  }

	const { data } = await api().rpc('get_user_subscribed_setups', {
		p_user_id,
	})

	return data || undefined
}

export function useSetups() {
	const [mode, setMode] = createSignal<'latest' | 'taken'>('latest')

	const [latestSetupsResource] = createResource(getLatestSetups)
	const [takenSetupsResource] = createResource(getTakenSetups)

	const currentSetups = createMemo(() => {
		return mode() === 'latest' ? latestSetupsResource : takenSetupsResource
	})

	return {
		mode,
		setMode,
		latestSetupsResource,
		takenSetupsResource,
		currentSetups,
	}
}
